import { css } from '@emotion/css'
import { colors, spacing } from '@offerzen/pinata'

const styles = {
  wrapper: css({
    hr: {
      margin: 0,
      marginBottom: spacing.extraLarge,
      border: `1px solid ${colors.geyser}`,
    },
  }),

  successNotification: css({
    margin: 0,
  }),

  acceptTermsForm: css({
    marginBottom: spacing.medium,
  }),
}

export default styles
